import { IEcole } from './ecole.model';

export interface IApprovisonnement {
  montant?: number;
  id?: string;
  description?: string;
  dateEmission?: string;
  dateValidation?: string;
  statutApprovisonnement?: string;
  ecoleId?: string;
  anneeScolaireId?: string;
  compteSalaireId?: string;
  ecole?: IEcole | null;
  typeApprovisonnement?: string;
  preuveId?: string | null;
  size?: number;
  page?: number;
  depotsBanque?: string;
  omMontant?: number;
  waveMontant?: number;
}

export const defaultValue: Readonly<IApprovisonnement> = {
  montant: 0,
  description: '',
  dateEmission: '',
  dateValidation: '',
  statutApprovisonnement: '',
  ecoleId: '',
  anneeScolaireId: '',
  compteSalaireId: '',
  typeApprovisonnement: '',
  id: null,
  preuveId: '',
  ecole: null,
  page: 0,
  size: 0,
  depotsBanque: '',
  omMontant: 0,
  waveMontant: 0,
};
